"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../../index");

var _DateHelper = _interopRequireDefault(require("../../../../util/DateHelper"));

var _NumberHelper = _interopRequireDefault(require("../../../../util/NumberHelper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var TransactionBasicInfo = /*#__PURE__*/function (_Component) {
  _inherits(TransactionBasicInfo, _Component);

  function TransactionBasicInfo(props) {
    var _this;

    _classCallCheck(this, TransactionBasicInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransactionBasicInfo).call(this, props));
    _this.state = {
      loading: false,
      showStolenModal: false
    };
    return _this;
  }

  _createClass(TransactionBasicInfo, [{
    key: "render",
    value: function render() {
      var transaction = this.props.transaction;
      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "row"
      }, this.state.loading === true ? _react["default"].createElement(_index.LoadingOverlay, null) : null, _react["default"].createElement("div", {
        className: "col-xl-12"
      }, _react["default"].createElement("div", {
        className: "element-with-blur"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header marginless"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-exchange"
      }), " Transaction Summary")), _react["default"].createElement("div", {
        className: "box-body text-white padded"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-sm-6"
      }, _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Note:"), _react["default"].createElement("dd", null, transaction.note), _react["default"].createElement("dt", null, "Amount:"), _react["default"].createElement("dd", null, _NumberHelper["default"].currency(transaction.amount, transaction.amountCurrency)), _react["default"].createElement("dt", null, "Category Name:"), _react["default"].createElement("dd", null, transaction.categoryName || '-'), _react["default"].createElement("dt", null, "transactionDate:"), _react["default"].createElement("dd", null, _DateHelper["default"].date(transaction.transactionDate, 'D / MMMM / Y')), _react["default"].createElement("dt", null, "Type:"), _react["default"].createElement("dd", null, transaction.type), _react["default"].createElement("dt", null, "Status:"), _react["default"].createElement("dd", null, transaction.status)))))))));
    }
  }]);

  return TransactionBasicInfo;
}(_react.Component);

exports["default"] = TransactionBasicInfo;